import { FormattedMessage } from 'react-intl';

import { Button, Text } from '@/modules/ui';

import { ReviewPrizepoolStep } from '../../constants';
import { useReviewPrizepoolStore } from '../../services/store';
import { ReviewPrizepoolLayout } from '../ReviewPrizepoolLayout';
import { ReviewPrizepoolForm } from './ReviewPrizepoolForm';

export const ReviewPrizepoolSteps = () => {
    const step = useReviewPrizepoolStore(state => state.step);
    const setStep = useReviewPrizepoolStore(state => state.setStep);
    const dismiss = useReviewPrizepoolStore(state => state.dismiss);

    switch (step) {
        case ReviewPrizepoolStep.Intro:
            return (
                <ReviewPrizepoolLayout
                    showImage
                    title='review-prizepool.intro.title'
                    content={
                        <Text preserveNewLines>
                            <FormattedMessage id='review-prizepool.intro.text' />
                        </Text>
                    }
                    buttons={
                        <>
                            <Button type='primary' size='large' onClick={() => setStep(ReviewPrizepoolStep.Form)}>
                                <FormattedMessage id='review-prizepool.intro.button.next' />
                            </Button>
                            <Button type='link' size='large' onClick={dismiss}>
                                <FormattedMessage id='review-prizepool.intro.button.ignore' />
                            </Button>
                        </>
                    }
                />
            );

        case ReviewPrizepoolStep.Form:
            return (
                <ReviewPrizepoolLayout
                    title='review-prizepool.form.title'
                    content={<ReviewPrizepoolForm onSubmitSuccess={() => setStep(ReviewPrizepoolStep.ThankYou)} onClose={dismiss} />}
                />
            );

        case ReviewPrizepoolStep.ThankYou:
            return (
                <ReviewPrizepoolLayout
                    showImage
                    title='review-prizepool.thankYou.title'
                    content={
                        <Text preserveNewLines>
                            <FormattedMessage id='review-prizepool.thankYou.text' />
                        </Text>
                    }
                    buttons={
                        <Button type='default' size='large' onClick={dismiss}>
                            <FormattedMessage id='review-prizepool.thankYou.button.close' />
                        </Button>
                    }
                />
            );

        default:
            return null;
    }
};
